import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { captureError } from '../common/sentry';

export type WarehouseEmailConfig = {
  warehouseId: string;
  warehouseLabel: string;
  emails: string[];
  coordinatorEmails: string[];
};

type ListWarehouseEmailConfigQuery = {
  listWarehouseEmailConfig: WarehouseEmailConfig[];
};

const listWarehouseEmailConfigQuery = `
  query ListWarehouseEmailConfig {
    listWarehouseEmailConfig {
      warehouseId
      warehouseLabel
      emails
      coordinatorEmails
    }
  }
`;

export async function listWarehouseEmailConfigRequest(): Promise<WarehouseEmailConfig[]> {
  try {
    const result = (await API.graphql(
      graphqlOperation(listWarehouseEmailConfigQuery)
    )) as GraphQLResult<ListWarehouseEmailConfigQuery>;

    return result.data?.listWarehouseEmailConfig ?? [];
  } catch (error) {
    captureError(error, 'warehouseConfig-listWarehouseEmailConfig');
    throw error;
  }
}
